import { useDisclosure } from '@mantine/hooks';
import { Modal, Text } from '@mantine/core';
import './PromotionModal.css';

function PromotionModal({ title, message, courses, actions, image, content, onClose }) {
    const [opened, { open, close }] = useDisclosure(true);
    const handleClose = () => {
        close(); // Cierra el modal visualmente (estado interno)
        if (onClose) onClose(); // Ejecuta la lógica del padre (localStorage)
    };
    return (
        <>
            <Modal opened={opened}
                onClose={handleClose}
                title={title}
                styles={{
                    title: {
                        textAlign: 'center',
                        width: '100%',
                        margin: 'auto',
                    }
                }}
                centered size="xl"
                classNames={{
                    title: "promotionModal__title",
                }}
            >
                {message &&
                    <Text size="lg" weight={500} ta="center">{message}</Text>
                }

                {courses && courses.length > 0 &&
                    <div className="promotionModal__container">
                        {courses.map((course) => (
                            <Text size="sm">✅ {course}</Text>
                        ))}
                    </div>
                }

                {content}

                {image &&
                    <img src={image} alt="Promotion" className="promotionModal__image" />
                }

                <div className="promotionModal__container--row">
                    {actions}
                </div>
            </Modal>
        </>
    );
}

export default PromotionModal;